import { Component, Input, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'role-option-launch-select-dropdown',
  templateUrl: './role.dropdown.launch.component.html',
  styleUrls: ['./role.dropdown.launch.component.css'],
})
export class RoleLaunchDropdownComponent implements OnInit, OnDestroy {
  @Input() role: any;
  ngOnInit(): void {}

  constructor() {}

  ngOnDestroy(): void {}
}
